export default function genererCriteresRechercheLigneARenouveler() {
  return {
    auto: '',
    pointDeVenteIds: [],
    enseigneIds: [],
    groupeIds: [],
    commercialId: [],
    estFacture: null,
  };
}
